import MuiAlert, { AlertProps } from '@mui/material/Alert';

export interface IAlertProps extends AlertProps {}

const Alert = (props: IAlertProps): JSX.Element => {
  return <MuiAlert {...props} />;
};

export default Alert;
